import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { setupAnchorLinks } from './utils/scrollToSection';
// Layout components
import PublicLayout from './components/layout/PublicLayout';
import AdminLayout from './components/admin/AdminLayout';
import { AdminProvider } from './contexts/AdminContext';
import { SiteContentProvider } from './contexts/SiteContentContext';
// Public pages
import Home from './pages/Home';
import About from './pages/About';
import Campus from './pages/Campus';
import Academics from './pages/Academics';
import Admissions from './pages/Admissions';
import StudentLife from './pages/StudentLife';
import News from './pages/News';
import Events from './pages/Events';
import Gallery from './pages/Gallery';
import PTA from './pages/PTA';
import Alumni from './pages/Alumni';
import Scholarships from './pages/Scholarships';
import Support from './pages/Support';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import VirtualTour from './pages/VirtualTour';
import NewsDetail from './pages/NewsDetail';
import EventDetail from './pages/EventDetail';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import Sitemap from './pages/Sitemap';
import Testimonials from './pages/Testimonials';
import ClubsAndSocieties from './pages/ClubsAndSocieties';
import AlumniEvents from './pages/AlumniEvents';
import AlumniJoin from './pages/AlumniJoin';
import AlumniExcos from './pages/AlumniExcos';
import CorporatePartnerships from './pages/CorporatePartnerships';
import EmmanuelChurch from './pages/EmmanuelChurch';
import IslamicReligion from './pages/IslamicReligion';
import ProjectCommissioning from './pages/ProjectCommissioning';
import TownHistory from './pages/TownHistory';
import Search from './pages/Search';
import PrizesAndAwards from './pages/PrizesAndAwards';
import IsonyinCommunity from './pages/IsonyinCommunity';
import Anniversary from './pages/Anniversary';
import AnniversaryGallery from './pages/AnniversaryGallery';
import AnniversaryNews from './pages/AnniversaryNews';
// Admin pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import ContentManager from './pages/admin/ContentManager';
import MediaManager from './pages/admin/MediaManager';
import PeopleManager from './pages/admin/PeopleManager';
import AnniversaryManager from './pages/admin/AnniversaryManager';
import SettingsManager from './pages/admin/SettingsManager';
export function App() {
  useEffect(() => {
    const cleanup = setupAnchorLinks();
    return cleanup;
  }, []);
  return <AdminProvider data-id="element-0">
      <SiteContentProvider data-id="element-1">
        <Router data-id="element-2">
          <Routes data-id="element-3">
            {/* Admin Routes — no public Header/Footer */}
            <Route path="/admin/login" element={<AdminLogin data-id="element-5" />} data-id="element-4" />
            <Route path="/admin" element={<AdminLayout data-id="element-7" />} data-id="element-6">
              <Route index element={<AdminDashboard data-id="element-9" />} data-id="element-8" />
              <Route path="content" element={<ContentManager data-id="element-11" />} data-id="element-10" />
              <Route path="media" element={<MediaManager data-id="element-13" />} data-id="element-12" />
              <Route path="people" element={<PeopleManager data-id="element-15" />} data-id="element-14" />
              <Route path="anniversary" element={<AnniversaryManager data-id="element-17" />} data-id="element-16" />
              <Route path="settings" element={<SettingsManager data-id="element-19" />} data-id="element-18" />
            </Route>

            {/* Public Routes — with Header/Footer via PublicLayout */}
            <Route element={<PublicLayout data-id="element-21" />} data-id="element-20">
              <Route path="/" element={<Home data-id="element-23" />} data-id="element-22" />
              <Route path="/about" element={<About data-id="element-25" />} data-id="element-24" />
              <Route path="/campus" element={<Campus data-id="element-27" />} data-id="element-26" />
              <Route path="/academics" element={<Academics data-id="element-29" />} data-id="element-28" />
              <Route path="/admissions" element={<Admissions data-id="element-31" />} data-id="element-30" />
              <Route path="/student-life" element={<StudentLife data-id="element-33" />} data-id="element-32" />
              <Route path="/news" element={<News data-id="element-35" />} data-id="element-34" />
              <Route path="/events" element={<Events data-id="element-37" />} data-id="element-36" />
              <Route path="/gallery" element={<Gallery data-id="element-39" />} data-id="element-38" />
              <Route path="/pta" element={<PTA data-id="element-41" />} data-id="element-40" />
              <Route path="/alumni" element={<Alumni data-id="element-43" />} data-id="element-42" />
              <Route path="/scholarships" element={<Scholarships data-id="element-45" />} data-id="element-44" />
              <Route path="/support" element={<Support data-id="element-47" />} data-id="element-46" />
              <Route path="/contact" element={<Contact data-id="element-49" />} data-id="element-48" />
              <Route path="/search" element={<Search data-id="element-51" />} data-id="element-50" />
              <Route path="/prizes-and-awards" element={<PrizesAndAwards data-id="element-53" />} data-id="element-52" />
              <Route path="/virtual-tour" element={<VirtualTour data-id="element-55" />} data-id="element-54" />
              <Route path="/news/:slug" element={<NewsDetail data-id="element-57" />} data-id="element-56" />
              <Route path="/events/:slug" element={<EventDetail data-id="element-59" />} data-id="element-58" />
              <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-61" />} data-id="element-60" />
              <Route path="/terms-of-use" element={<TermsOfUse data-id="element-63" />} data-id="element-62" />
              <Route path="/sitemap" element={<Sitemap data-id="element-65" />} data-id="element-64" />
              <Route path="/testimonials" element={<Testimonials data-id="element-67" />} data-id="element-66" />
              <Route path="/student-life/clubs" element={<ClubsAndSocieties data-id="element-69" />} data-id="element-68" />
              <Route path="/isonyin-community" element={<IsonyinCommunity data-id="element-71" />} data-id="element-70" />
              <Route path="/emmanuel-church" element={<EmmanuelChurch data-id="element-73" />} data-id="element-72" />
              <Route path="/islamic-religion" element={<IslamicReligion data-id="element-75" />} data-id="element-74" />
              <Route path="/project-commissioning" element={<ProjectCommissioning data-id="element-77" />} data-id="element-76" />
              <Route path="/town-history" element={<TownHistory data-id="element-79" />} data-id="element-78" />
              <Route path="/alumni/events" element={<AlumniEvents data-id="element-81" />} data-id="element-80" />
              <Route path="/alumni/join" element={<AlumniJoin data-id="element-83" />} data-id="element-82" />
              <Route path="/alumni/excos" element={<AlumniExcos data-id="element-85" />} data-id="element-84" />
              <Route path="/anniversary" element={<Anniversary data-id="element-87" />} data-id="element-86" />
              <Route path="/anniversary-gallery" element={<AnniversaryGallery data-id="element-89" />} data-id="element-88" />
              <Route path="/anniversary-news" element={<AnniversaryNews data-id="element-91" />} data-id="element-90" />
              <Route path="/support/corporate-partnerships" element={<CorporatePartnerships data-id="element-93" />} data-id="element-92" />
              <Route path="*" element={<NotFound data-id="element-95" />} data-id="element-94" />
            </Route>
          </Routes>
        </Router>
      </SiteContentProvider>
    </AdminProvider>;
}